import styled from 'styled-components';
import MenuItemUI from '@material-ui/core/MenuItem';
import SelectUI from '@material-ui/core/Select';

// CONSTANTS
import { ATHENS_GRAY } from '@/constants/colors';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.div`
  position: relative;
  padding: 30px 0 150px;

  ${breakpoints.down('xs')} {
    padding: 30px 0 50px;
  }

  .episodes {
    &__title {
      font-weight: 700;
      line-height: 3rem;
      margin-bottom: 30px;
    }

    &__services {
      position: relative;
      margin-bottom: 32px;

      .services {
        &__title {
          font-size: 2.4rem;
          margin-right: 65px;
        }
      }
    }
  }

  .services-carousel {
    margin-top: -34px;

    .swiper-slide {
      width: 403px;
    }
  }

  .services-carousel,
  .episodes-carousel {
    ${breakpoints.down('xs')} {
      .swiper-button-prev {
        &::after {
          content: '\\e926';
        }
      }

      .swiper-button-next {
        &::after {
          content: '\\e909';
        }
      }
    }
  }
`;

export const Select = styled(SelectUI)`
  width: 170px;
  margin-bottom: 30px;

  .MuiSelect-select {
    padding: 16px 50px 16px 18px;
    background: ${ATHENS_GRAY};
  }

  .MuiOutlinedInput-notchedOutline {
    border: 0;
  }
`;

export const MenuItem = styled(MenuItemUI)`
  display: flex;
  justify-content: space-between;
  padding: 12px;

  .menu-item {
    &__right {
      flex: 1;
      text-align: right;
      margin-left: 60px;
    }
  }
`;

export default Container;
